module.exports = __webpack_public_path__ + "img/a2.b56bd9a5.jpg";